"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_TYPES = void 0;
var EVENT_TYPES = {
  "treatmentPlan.activated": "treatmentPlan.activated",
  "patient.selected": "patient.selected"
};
exports.EVENT_TYPES = EVENT_TYPES;